import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';

/**
 * here we're dropping old symbols at the beginning of new spin
 */
export class AvalancheReelsDropOutState extends ModuleState<AvalancheReelsView, AvalancheReelsModule> {
	public onEnterState(): void {
		this.emit(ReelsEvents.REELS_SPINNING_STARTED);
		this.view.showAllSymbols();
		this.view.dropOut();
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(AvalancheReelsView.ALL_REELS_DROPPED_OUT, this.onAllReelsDroppedOut);
	}

	protected onAllReelsDroppedOut(): void {
		this.module.gotoState(AvalancheReelsModule.DROPNEW_STATE);
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheReelsDropOutState.ts